module.exports = "/assets/13bb140eb052169cb9b2ba96355fa4d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BI.png
// module id = 2360
// module chunks = 0